import { styled } from '@linaria/react';

import { random } from '@/utils';

import { ENVIRONMENT_WIDTH, ENVIRONMENT_HEIGHT } from './constants';

const IMG_ROOT = '/images/a-friendly-introduction-to-spring-physics';

const IMAGES = {
  planet1: `${IMG_ROOT}/gaseous-planet.png`,
  planet2: `${IMG_ROOT}/shard-planet.png`,
  background: `${IMG_ROOT}/space-bg.jpg`,
};

const Planet = ({ x, y, motionPath, src, width, duration }) => {
  return (
    <PlanetImg
      src={src}
      style={{
        width,
        top: y,
        offsetPath: `path('${motionPath}')`,
        animationDuration: duration + 'ms',
      }}
    />
  );
};

const Cover = () => {
  return (
    <svg viewBox="0 0 491 145" style={{ width: '100%' }}>
      <path
        d="M0 144.5V0.5H490.5V39C490.5 39 463.251 32.066 445.5 32.5C393.509 33.7712 378.985 120.551 331 100.5C313.099 93.02 311.386 74.6931 293 68.5C245.5 52.5 214.348 62.0443 165.5 68.5C92.0652 78.205 0 144.5 0 144.5Z"
        fill="var(--color-background)"
      />
    </svg>
  );
};

const generateSparklePosition = () => {
  return {
    left: random(0, 95) + '%',
    top: random(0, 98) + '%',
  };
};

const EarthBackground = () => {
  return (
    <Wrapper>
      <CoverWrapper>
        <Cover />
      </CoverWrapper>
      <Planet
        x={ENVIRONMENT_WIDTH * 0.6}
        y={0}
        motionPath="M191.297 60.4795C193.069 76.9426 184.449 93.0142 168.942 105.688C153.44 118.358 131.102 127.583 105.601 130.329C80.1004 133.074 56.3109 128.814 38.4667 119.734C20.6176 110.652 8.77468 96.783 7.00233 80.3198C5.22998 63.8567 13.8497 47.7851 29.3566 35.1117C44.8593 22.4416 67.197 13.2161 92.6977 10.4708C118.198 7.72551 141.988 11.9852 159.832 21.0652C177.681 30.1477 189.524 44.0164 191.297 60.4795Z"
        src={IMAGES.planet1}
        duration={60000}
        width={100}
      />
      <Planet
        x={ENVIRONMENT_WIDTH * 0.1}
        y={ENVIRONMENT_HEIGHT * 0.5}
        motionPath="M83.5 8.5C53.7174 28.4021 111.152 63.9236 144.5 77C171.404 87.5497 199.812 54.9569 218.5 77C238.224 100.265 221.881 131.248 200.5 153C180.755 173.087 146.428 150.115 131.5 174C109.161 209.743 198.724 206.677 211 247C234.919 325.566 24.9436 357.14 3 278C-18.6315 199.985 189.468 263.421 187 182.5C186.109 153.284 180.553 133.767 160.5 112.5C136.268 86.8012 84.1261 117.122 75 83C65.3292 46.8411 169.592 44.7735 144.5 17C128.376 -0.847078 103.498 -4.86358 83.5 8.5Z"
        src={IMAGES.planet2}
        duration={180000}
        width={100}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  background-image: url(${IMAGES.background});
  background-size: cover;
`;

const PlanetImg = styled.img`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  display: block;
  will-change: transform;
  animation: moveAlongPath linear infinite;
  offset-rotate: 0deg;

  @keyframes moveAlongPath {
    0% {
      offset-distance: 0%;
    }
    100% {
      offset-distance: 100%;
    }
  }
`;

const CoverWrapper = styled.div`
  position: absolute;
  top: -2px;
  left: -1px;
  right: -1px;
  z-index: 2;
`;

export default EarthBackground;
